export function loadHookImage(image: string): string {
  // eslint-disable-next-line import/no-dynamic-require,global-require
  return require(`../../../img/vendor/hooks/${image}.png`).default;
}
